module.exports = __webpack_public_path__ + "img/389650ab514d27b996578aa1b32116fc.dd7c09db.png";